<ng-container *ngIf="isStandalone; else sharedTemplate">
  <hfc-standalone-form-container [showButtons]="false" [showTimeLine]="false">
    <h1>Contact Preferences</h1>
    <ng-container *ngIf="communicationPreferencesData$ | async as commsPreferences">
      <hfc-contact-preference
        [isStandalone]="true"
        [userEmail]="commsPreferences?.maskedEmail"
        [userPhoneNumber]="commsPreferences?.maskedPhone"
        [commsPreferences]="commsPreferences?.commsPreferences"
        [tokenId]="tokenId"
      ></hfc-contact-preference>
    </ng-container>
  </hfc-standalone-form-container>
</ng-container>

<ng-template #sharedTemplate>
  <hfc-standalone-form-container
    [showButtons]="true"
    [showTimeLine]="true"
    [nextLabel]="'Save and Complete'"
    [showCopyright]="true"
    [timeLineContent]="timeLineContent"
    (nextAction)="onConfirmCommsPreferences()"
    ><h1>Contact Preferences</h1>
    <ng-container *ngIf="communicationPreferencesData$ | async as commsPreferences">
      <hfc-contact-preference
        [isStandalone]="false"
        [commsPreferences]="commsPreferences?.commsPreferences"
        [tokenId]="tokenId"
        [clientId]="clientId"
        (commsPreferencesChanged)="onCommsPreferencesChanged($event)"
      ></hfc-contact-preference>
    </ng-container>
  </hfc-standalone-form-container>
</ng-template>
